/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { getBrand, getFeatureFlags } from '../../../state/ducks/App/ducks/Config/Config-Selectors';

const LoyaltySchema = (path) => {
    const brand = useSelector(getBrand);
    const featureFlags =  useSelector(getFeatureFlags);
    const celebrationsPath = featureFlags['seo-schema-passport-path-table']?.[brand.domain] || '/passport-flowers';
    return (
        <Helmet>
            <script type="application/ld+json">
                {
                `{
                   "@context": "https://schema.org",
                    "@type": "MemberProgram",
                    "@id": "https://www.${brand.domain}.com${path.path}#celebrations-passport",
                    "name": "Celebrations Passport",
                    "url": "https://www.${brand.domain}.com${path.path}",
                    "description": "Celebrations Passport is an annual paid loyalty program offering free standard shipping and no service charge on eligible gifts across the 1-800-Flowers.com family of brands.",
                    "hostingOrganization": {
                        "@type": "Organization",
                        "@id": "https://www.1800flowers.com/#organization",
                        "name": "1-800-Flowers.com",
                        "url": "https://www.1800flowers.com"
                    },
                    "hasTiers": [{
                        "@type": "MemberProgramTier",
                        "@id": "https://www.${brand.domain}.com${celebrationsPath}#celebrations-passport-tier",
                        "name": "Passport Member",
                        "hasTierBenefit": [
                            "https://schema.org/TierBenefitLoyaltyShipping"
                            ]
                        }
                    ]
                }`
                }
            </script>
        </Helmet>
    );
};

export default LoyaltySchema;
